/**
 * TGTHR Rebuy Bundle Builder - Post-render enhancer for widget 266294
 * Scoped to #rebuy-widget-266294 only.
 * Uses MutationObserver to re-apply enhancements when Rebuy re-renders
 * (e.g. tier change, adding items). Keeps DOM class toggles minimal.
 */
(function () {
  'use strict';

  const WIDGET_ID = 'rebuy-widget-266294';

  function enhance() {
    const root = document.getElementById(WIDGET_ID);
    if (!root) return;

    root.classList.add('tgthr-bb-enhanced');

    // Ensure tier bubbles are horizontally laid out (fix any drift)
    const tiersList = root.querySelector('.tgthr-bb__tiers-list');
    if (tiersList) {
      tiersList.style.display = 'flex';
      tiersList.style.flexWrap = 'wrap';
      tiersList.style.gap = '0.5rem';
    }

    // Center tier list on mobile when scrollable
    const tierBubbles = root.querySelectorAll('.tgthr-bb__tier-bubble');
    if (tierBubbles.length > 5 && window.innerWidth < 768) {
      const container = root.querySelector('.tgthr-bb__tiers-bar');
      if (container) container.style.overflowX = 'auto';
    }
  }

  function run() {
    enhance();

    const root = document.getElementById(WIDGET_ID);
    if (!root) return;

    const observer = new MutationObserver(function () {
      enhance();
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run when Rebuy might have injected the widget late
  if (typeof window !== 'undefined') {
    window.addEventListener('load', function () {
      setTimeout(enhance, 500);
      setTimeout(enhance, 1500);
    });
  }
})();
